import { axiosClient } from '../axios';

export const sendMessage = (messageId, event, eventDetails = {}, result = 'success') => {
  axiosClient.post('/message', {
    messageId, event, eventDetails, result,
  });
};
